import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { TextInput } from '@els/els-react--text-input';
import { ButtonWithIcon } from '@els/els-react--button';
import classnames from 'classnames';
import { molecularModalReducerKey } from '../MolecularModalConstants';
import { updateStateParams, dispatchCloseMolecularModal } from '../MolecularModalActions';

function Header({ getCursorPosition = () => {}, inputRef, updateStringTypeDataValue = () => {} }) {
  const { formulaText } = useSelector((state) => state.get(molecularModalReducerKey));
  const dispatch = useDispatch();
  const [isTextBoxFocused, setTextBoxFocus] = useState(false);
  const trimmedName = formulaText.trim();

  return (
    <div className="rx-formula__header clearfix">
      <div className="col-sm-8">
        <div className="els-text-input rx-formula__query medium">
          <TextInput
            id="rx-formula-query-input"
            data-e2e="molecular-formula-input"
            inputRef={inputRef}
            name="name"
            className={classnames('e2e-molecular-formula', { inactive: !isTextBoxFocused && trimmedName.length === 0 })}
            label="Molecular formula"
            shouldHideLabel
            placeholder="Molecular formula:"
            value={formulaText || ''}
            onChange={(event) => {
              const value = event?.target?.value ?? event?.currentTarget?.value ?? '';
              dispatch(updateStateParams({ formulaText: value }));
              setTextBoxFocus(true);
            }}
            onBlur={(e) => {
              getCursorPosition(e.target?.selectionStart, e.target?.selectionEnd);
              setTextBoxFocus(false);
            }}
            onMouseDown={() => {
              setTextBoxFocus(true);
            }}
            tabIndex="0"
          />
        </div>
      </div>
      <div className="col-sm-4">
        <ButtonWithIcon
          data-e2e="molecular-modal-use-formula"
          type="primary"
          sprite="ChevronRight"
          linkIconSize="s"
          iconRight
          aria-label="Use this formula"
          disabled={trimmedName === ''}
          onClick={() => {
            updateStringTypeDataValue(formulaText);
            dispatchCloseMolecularModal();
          }}
          className="e2e-molecular-modal-use-formula">
          Use this formula
        </ButtonWithIcon>
      </div>
    </div>
  );
}

Header.propTypes = {
  getCursorPosition: PropTypes.func,
  inputRef: PropTypes.any,
  updateStringTypeDataValue: PropTypes.func,
};

export default Header;
